import generateId from 'src/lib/generateId';

const generateAlphaNumericId = () => {
  const id = generateId();

  return id.replace(/-/g, '_');
};

export default generateAlphaNumericId;
